<template>
    <Form>
        <h2>Email confirmation</h2>
        <v-alert v-if="error" color="red" icon="mdi-alert-octagon-outline" outlined text>
            We were unable to confirm your email address. Please <router-link :to="{ name: 'account' }">resend</router-link> the confirmation email
            and try again.
        </v-alert>
        <p v-else>
            {{ message }}
            <v-progress-circular v-if="loading" indeterminate size="20" color="green"></v-progress-circular>
        </p>
    </Form>
</template>

<script>
import Form from '@/pages/Form';

export default {
    components: { Form },
    data() {
        return {
            message: 'Email confirmation is in progress.',
            loading: true,
            error: false,
        };
    },
    created() {
        this.$api.activateAccount(this.$route.query.t, (data, meta) => {
            this.loading = false;
            if (meta.error) {
                this.error = true;
                return;
            }
            if (data.return_url) {
                window.location.href = data.return_url;
                return;
            }
            this.message = 'Your email has been confirmed successfully! Redirecting to your account...';
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
                this.$router.push({ name: 'account' });
            }, 3000);
        });
    },
};
</script>

<style scoped></style>
